<script lang="ts" setup>
import { IToastOptions } from '@/services/toaster/types';

// Props.
interface Props {
  content: string,
  dataTestid?: string,
  id: string,
  options: IToastOptions,
  toastId: string,
}

withDefaults(defineProps<Props>(), {
  dataTestid: 'toast',
});

defineEmits(['close-toast']);
</script>

<template>
  <strong
    v-if="options.context"
    class="zo-toast--context"
    :data-testid="`${dataTestid}_${options.type}_context`"
    v-html="options.context"
  />
  <div
    class="zo-toast--content"
    :data-testid="`${dataTestid}_${options.type}_description`"
    v-html="content"
  />
</template>
